// The index wraps each matched word independently. Keep whitespace between
// adjacent matches inside the same mark, without highlighting unrelated text.
export const mergeSearchHighlights = (html: string): string =>
  html.replace(/<\/mark>((?:\s|&nbsp;|&#160;|&#x0*a0;)*)<mark>/gi, "$1")

export function searchHighlightTerms(html: string): string[] {
  const document = new DOMParser().parseFromString(
    mergeSearchHighlights(html),
    "text/html",
  )
  return [...document.querySelectorAll("mark")]
    .map((mark) => mark.textContent?.trim() || "")
    .filter(Boolean)
}

export function searchMetadataMatch(html: string): string {
  return mergeSearchHighlights(html)
    .split(/\r?\n/)
    .filter((line) => /<mark>/i.test(line))
    .slice(0, 2)
    .join("\n")
}
